import clsx from 'clsx';

const TabSelector = ({ tabOptions, changeTab, selectedTab }) => {
  return (
    <div className="tab-selector">
      {tabOptions.map((tabOption) => {
        let tabClasses = clsx('tab', {
          selected: tabOption.value === selectedTab,
        });

        let iconClasses = clsx(tabOption.iconClassName, {
          selected: tabOption.value === selectedTab,
        });

        return (
          <div
            onClick={() => changeTab(tabOption.value)}
            key={tabOption.value}
            className={tabClasses}
          >
            <span className={iconClasses}></span>
            <span>{tabOption.text}</span>
          </div>
        );
      })}
    </div>
  );
};

/**
 * @deprecated
 */
export default TabSelector;
